export const SITE_URL = "https://chichawasi.pe";

export const ROUTES = {
  home: "/",
  booking: "/reserva",
  about: "/sobre-nosotros",
  tourism: "/turismo",
  contact: "/contactanos",
} as const;

export const HOME_SECTIONS = {
  cabins: "/#cabins-showcase",
  amenities: "/#amenities-cabanas",
  testimonials: "/#testimonios",
  policies: "/#politicas",
  legal: "/#aviso-legal",
  privacy: "/#privacidad",
  cookies: "/#cookies",
  accessibility: "/#accesibilidad",
} as const;

type SeoEntry = {
  title: string;
  description: string;
};

const SEO_BY_PATH: Record<string, SeoEntry> = {
  "/": {
    title: "Chichawasi | Cabanas en Oxapampa",
    description:
      "Cabanas en Oxapampa para descansar en la naturaleza. Conoce Chichawasi, explora sus servicios y reserva tu estadia.",
  },
  [ROUTES.booking]: {
    title: "Reserva tu cabana en Oxapampa | Chichawasi",
    description:
      "Consulta disponibilidad, conoce las cabanas y reserva tu hospedaje en Oxapampa directamente con Chichawasi.",
  },
  [ROUTES.about]: {
    title: "Sobre nosotros | Chichawasi",
    description:
      "Conoce la historia, la vision y la experiencia familiar que Chichawasi ofrece en Oxapampa.",
  },
  [ROUTES.tourism]: {
    title: "Mapa turistico de Oxapampa | Chichawasi",
    description:
      "Descubre lugares para visitar en Oxapampa, rutas recomendadas y puntos de interes cerca de Chichawasi.",
  },
  [ROUTES.contact]: {
    title: "Contacto | Chichawasi",
    description:
      "Contacta a Chichawasi para reservas, consultas y ubicacion de nuestras cabanas en Oxapampa.",
  },
};

function normalizePath(pathname: string) {
  const cleaned = pathname.replace(/\/+$/, "");
  return cleaned || "/";
}

export function getCanonicalUrl(pathname: string) {
  const normalized = normalizePath(pathname);
  return `${SITE_URL}${normalized === "/" ? "/" : normalized}`;
}

export function getSeoForPath(pathname: string) {
  const normalized = normalizePath(pathname);
  const seo = SEO_BY_PATH[normalized] ?? SEO_BY_PATH["/"];

  return {
    ...seo,
    canonical: getCanonicalUrl(normalized),
  };
}
